/**
 * PrimeVue v-tooltip só trata corretamente valores string (ou objeto de opções).
 * Números, boolean, VNode etc. podem quebrar o ciclo create/align do tooltip.
 *
 * @param {unknown} value
 * @returns {string | undefined}
 */
export function primeTooltipString(value) {
  if (value === null || value === undefined || value === false) {
    return undefined;
  }
  if (typeof value === "string") {
    const t = value.trim();
    return t === "" ? undefined : t;
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? String(value) : undefined;
  }
  if (typeof value === "bigint") {
    return String(value);
  }
  if (typeof value === "boolean") {
    return undefined;
  }
  if (typeof value === "object") {
    return undefined;
  }
  try {
    return String(value);
  } catch {
    return undefined;
  }
}
